import React, { useEffect, useState } from 'react'
import StaffOverviewCard from '../../../components/partials/staff/StaffOverviewCard'
import StaffDetails from '../../../components/partials/staff/StaffDetails'
import StaffEmployment from '../../../components/partials/staff/StaffEmployment'
import StaffEmergencyContacts from '../../../components/partials/staff/StaffEmergencyContacts'
import StaffBankDetails from '../../../components/partials/staff/StaffBankDetails'
import StaffDocuments from '../../../components/partials/staff/StaffDocuments'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import Loader from '../../../components/elements/Loader'

const UserStaffProfile = () => {  
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [staffDetails, setStaffDetails] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [reload, setReload] = useState(0)

  useEffect(() => {
    const fetchStaffMember = async () => {
      try {
        const headers = authHeader()
        const response = await axios.get(`${baseUrl}/user/profile/staff?expand=department,designation,invitation,departmentHistory.department,designationHistory.designation`, { headers })
        
        setStaffDetails(response.data.data)
        setLoading(false)
      } catch (error) {
        console.error(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoading(false)
      }
    }

    fetchStaffMember()

    return () => {}
  }, [dispatch, reload])
  
  return (
    <div>
      <div className='w-full max-w-[1500px] mx-auto'>
        {loading ? 
          <Loader />
          :
          <div className='mt-6 flex flex-col items-start gap-6 xl:flex-row'>
            <div className='w-full xl:w-[250px] xl:shrink-0 xl:sticky xl:top-[150px]'>
              <StaffOverviewCard staff={staffDetails} reload={()=>{setReload(prev => prev + 1)}} />
            </div>
            <div className='w-full'>
              {/* <div className='flex w-full gap-1 overflow-x-auto border-b border-gray-200'>
                {staffTabs.map((tab, tabIndex) => (
                  <button 
                    key={tabIndex} 
                    className={`whitespace-nowrap rounded-t-lg px-4 py-3 text-sm font-medium transition ${activeTabIndex === tabIndex ? 'border-b-2 border-vcm-purple bg-vcm-light-purple/20 text-vcm-purple' : 'text-vcm-dark-gray hover:bg-gray-50 hover:text-vcm-purple'}`}
                    onClick={() => {changeTab(tabIndex)}}
                  >
                    {tab.label}
                  </button>
                ))}
              </div> */}

              <div className=''>
                <StaffDetails staff={staffDetails} reload={()=>{setReload(prev => prev + 1)}} />
                
                <div className='mt-6 pb-6 border-b border-gray-200'>
                    <StaffEmployment staff={staffDetails} />
                </div>
                <div className='mt-6 pb-6 border-b border-gray-200'>
                    <StaffEmergencyContacts staff={staffDetails} reload={()=>{setReload(prev => prev + 1)}} />
                </div>
                <div className='mt-6 pb-6 border-b border-gray-200'>
                    <StaffBankDetails staff={staffDetails} reload={()=>{setReload(prev => prev + 1)}} />
                </div>
                <div className='mt-6 pb-6'>
                    <StaffDocuments staff={staffDetails} reload={()=>{setReload(prev => prev + 1)}} />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default UserStaffProfile
